export const styles = theme => ({
  app: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    color: theme.palette.text.primary
  },
  appDark: {
    backgroundColor: theme.palette.primary[700]
  },
  app__content: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    flex: 1
  },
  container: {
    margin: 'auto',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem'
  },
  containerCenterContent: {
    display: 'flex',
    justifyContent: 'center'
  }
});



// WEBPACK FOOTER //
// ./src/styles/App.js